module.exports = __webpack_public_path__ + "img/img4.cbca90f4.png";